import * as Models from "../.";
export interface IContractEnvelopeRequest {
  inPerson: boolean;
  epcCalculationId: number;
  igsCustomerNumber: string;
  verifyByTextMessage?: boolean;
}

export class ContractEnvelopeRequest implements IContractEnvelopeRequest {
  inPerson: boolean;
  epcCalculationId: number;
  igsCustomerNumber: string;
  verifyByTextMessage?: boolean;

  constructor(igsCustomerNumber?: string) {
    this.inPerson = true;
    this.igsCustomerNumber = igsCustomerNumber;
  }
}
